// @ts-nocheck
if (!customElements.get('grid-columns-component')) {
  customElements.define('grid-columns-component', class GridColumnsComponent extends HTMLElement {
    connectedCallback() {
        const desktopColumns = this.#getColumnsFromBody('desktop') || '4';
        const mobileColumns = this.#getColumnsFromBody('mobile') || '2';

        this.#applyColumns('desktop', desktopColumns);
        this.#applyColumns('mobile', mobileColumns);

        this.querySelectorAll('.grid-columns-buttons.desktop .column-button').forEach(button => {
            button.addEventListener('click', () => this.onColumnClick(button, 'desktop'));
        });

        this.querySelectorAll('.grid-columns-buttons.mobile .column-button').forEach(button => {
            button.addEventListener('click', () => this.onColumnClick(button, 'mobile'));
        });

        // Mobile: clicking "View" cycles 2 → 1 → 4 → repeat
        this.querySelector('.grid-columns-label')?.addEventListener('click', () => {
            if (window.innerWidth > 949) return;
            this.#cycleMobileColumns();
        });

        this.#observeGrid();
    }

    #cycleMobileColumns() {
        const cycle = ['2', '4', '1'];
        const current = this.#getColumnsFromBody('mobile') || '2';

        const currentIndex = cycle.indexOf(current);
        const nextIndex = (currentIndex + 1) % cycle.length;

        this.#applyColumns('mobile', cycle[nextIndex]);
    }

    #observer = null;

    #observeGrid() {
    const grid = document.querySelector('.grid-columns');
    if (!grid) return;

    this.#observer = new MutationObserver(() => {
        const desktopColumns = this.#getColumnsFromBody('desktop') || '4';
        const mobileColumns = this.#getColumnsFromBody('mobile') || '2';
        this.#updateImageSizes(desktopColumns, mobileColumns);
    });

    this.#observer.observe(grid, { childList: true, subtree: true });
    }

    disconnectedCallback() {
    this.#observer?.disconnect();
    }

    #applyColumns(device, columns) {
    document.documentElement.style.setProperty(`--${device}-columns`, columns);

    document.body.classList.forEach(cls => {
        if (cls.startsWith(`grid-${device}-`)) document.body.classList.remove(cls);
    });
    document.body.classList.add(`grid-${device}-${columns}`);

    const desktopColumns = this.#getColumnsFromBody('desktop') || '4';
    const mobileColumns = this.#getColumnsFromBody('mobile') || '2';
    this.#updateImageSizes(desktopColumns, mobileColumns);

    // Notify injected-items to re-inject
    window.dispatchEvent(new Event('grid-columns-change'));
    }

    #getColumnsFromBody(device) {
    const cls = Array.from(document.body.classList).find(c => c.startsWith(`grid-${device}-`));
    return cls ? cls.replace(`grid-${device}-`, '') : null;
    }

    #updateImageSizes(desktopColumns, mobileColumns) {
    const indexMap = {
        '8_4': 0, '8_2': 1, '8_1': 2,
        '4_4': 3, '4_2': 4, '4_1': 5,
        '2_4': 6, '2_2': 7, '2_1': 8
    };

    const key = `${desktopColumns}_${mobileColumns}`;
    const index = indexMap[key] ?? 4;

    document.querySelectorAll('img[data-all-sizes]:not(.featured-product-item)').forEach(img => {
        const allSizes = img.dataset.allSizes.split('|');
        if (allSizes[index]) img.sizes = allSizes[index];
    });
    }

    onColumnClick(button, device) {
    const columns = button.textContent.trim();
    this.#applyColumns(device, columns);
    }

  });
}